import { message } from "antd";

export function showMessage(messageObj: string, isSuccess: boolean) {
  if (isSuccess) {
    message.success(messageObj);
  } else {
    message.error(messageObj);
  }
}
